<div class="login-container">
    <div class="login-card">
      <h2 *ngIf="!showEmailPrompt">Authenticating...</h2>
      
      <div *ngIf="isLoading && !showEmailPrompt" class="spinner">
        Loading...
      </div>

      <div *ngIf="showEmailPrompt" class="email-prompt-container">
        <h2>Enter Email Address</h2>
        <p class="email-prompt-sub">Please enter your email to complete sign in and registration.</p>
        
        <form (ngSubmit)="submitEmail()" #emailForm="ngForm">
          <div class="input-group">
            <input type="email" name="email" [(ngModel)]="emailInput" placeholder="name@example.com" required email class="form-input">
          </div>
          <button type="submit" [disabled]="!emailForm.form.valid" class="submit-btn">
            Save & Continue
          </button>
        </form>
      </div>
  
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
        <button *ngIf="!showEmailPrompt" (click)="loginUsingAuthPortal()">Try Again</button>
      </div>

      <footer class="login-footer">
        <div class="footer-links">
          <a routerLink="/terms" target="_blank">Terms of Service</a>
          <span>&bull;</span>
          <a routerLink="/privacy" target="_blank">Privacy Policy</a>
        </div>
      </footer>
    </div>
</div>
